export default {
  schedule: {
    date_and_time: 'Dată și oră*',
    number_of_guests: 'Număr de invitați*',
    location: 'Locație:',
  },
  personal_information: {
    title: 'Titlu',
    first_name: 'Prenume',
    enter_first_name: 'Introduceți prenumele',
    last_name: 'Nume de familie*',
    enter_last_name: 'Introduceți numele de familie',
    email: 'Email',
    enter_email: 'Introduceți emailul',
    phone: 'Telefon',
    annotation: 'Adnotare',
    enter_annotation: 'Introduceți adnotarea',
  },
  gender: {
    without_title: 'Fără titlu',
    male: 'Dl',
    female: 'Dna.',
  },
  buttons: {
    save: 'Salvează',
  },
  error_messages: {
    invalid_email: 'Introduceți o adresă de e-mail validă, fără spații sau umlauturi înainte de @.',
    invalid_phone_number: 'Număr de telefon invalid. Verificați informațiile și încercați din nou.',
    failed_reservation: 'Trimiterea rezervării a eșuat. Verificați informațiile și încercați din nou.',
    invalid_reservation_day: 'Nu acceptăm rezervări în această zi.',
    no_tables_available: 'Ne pare rău, nu mai avem mese disponibile.',
    please_enter_guests: 'Introduceți numărul de persoane.',
    please_select_time: 'Selectați o oră.',
    please_select_last_name: 'Introduceți numele de familie',
  },
  success_messages: {
    reservation_saved: 'Rezervare salvată cu succes',
  },
};
